var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "api-bar-char-cla" },
    [
      _c("chartTop", {
        attrs: { title: _vm.$t("statistics.apiSort") },
        model: {
          value: _vm.time,
          callback: function($$v) {
            _vm.time = $$v
          },
          expression: "time"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "statistics-chart-box-cla",
          attrs: { id: "aipbarChart" }
        },
        [
          _c("zkLoading", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLoad,
                expression: "showLoad"
              }
            ],
            staticStyle: { "margin-top": "0" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19b7dfc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b7dfc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/statistics/apiStatistics/apiBarChar.vue
// module id = null
// module chunks = 